<section class="container-carousel">
  <p class="title">Nossos produtos</p>
  <swiper-container
    class="swiper-container swiper-wrapper"
    init="false"
    #carouselSwiper
  >
    @for(client of clients; track client.name) {
    <swiper-slide class="swiper-slide slide">
      <div class="content">
        <p>{{ client.name }}</p>
        <img [src]="client.img" alt="" />
      </div>
    </swiper-slide>
    }
  </swiper-container>
</section>
